import React from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import WaveSplitsGraph from "./WaveSplitsGraph";
import "./WaveSplits.css";
import FlexBreak from "../../../../../FlexBreak";

const QUERY = graphql`
  query WaveSplitsEventLookupQuery($eventId: ID!) {
    pgaTourEvent(eventId: $eventId) {
      pgatoureventcourseSet {
        edges {
          node {
            id
            course {
              name
            }
          }
        }
      }
    }
  }
`;

export default function WaveSplits({ eventId }) {
  const data = useLazyLoadQuery(QUERY, { eventId });

  return (
    <div>
      {data.pgaTourEvent.pgatoureventcourseSet.edges.map((eventCourseNode) => {
        const eventCourse = eventCourseNode.node;

        return (
          <div key={eventCourse.id}>
            <h2>{eventCourse.course.name}</h2>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
              }}
              key={eventCourse.id}
            >
              <div className="wave-splits-graph-container">
                <WaveSplitsGraph
                  eventId={eventId}
                  roundNum={1}
                  eventCourseId={eventCourse.id}
                />
              </div>
              <div className="wave-splits-graph-container">
                <WaveSplitsGraph
                  eventId={eventId}
                  roundNum={2}
                  eventCourseId={eventCourse.id}
                />
              </div>
              <div className="wave-splits-graph-container">
                <WaveSplitsGraph
                  eventId={eventId}
                  roundNum={3}
                  eventCourseId={eventCourse.id}
                />
              </div>
              <div className="wave-splits-graph-container">
                <WaveSplitsGraph
                  eventId={eventId}
                  roundNum={4}
                  eventCourseId={eventCourse.id}
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
